import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CelebrationCard from './CelebrationCard';
import TreeLottieCard from './TreeLottieCard';
import TreePlantedCard from './TreePlantedCard';
import Entity from '../../../../v3/Common/Entity';
import { getTreeBannersAction } from '../APIs/action';

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  arrows: false,
  true: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplaySpeed: 3000,
};
const TreeBannerCard = () => {
  const { selectedEntity } = useSelector((state) => state.entityReducer);
  const [banners, setBanners] = useState([]);
  const [phases, setPhases] = useState({});

  useEffect(() => {
    setPhases({});
    if (!selectedEntity) return;
    getTreeBannersAction(selectedEntity).then((res) => {
      if (!res?.error && Array.isArray(res?.data)) setBanners(res.data);
      else setBanners([]);
    });
  }, [selectedEntity]);

  const setPhase = (id, phase) =>
    setPhases((prev) => ({ ...prev, [id]: phase }));

  const renderBannerItem = (item) => {
    const id = item.plantation_id;
    const raw = item.plantation_card?.occasion ?? 'Birthday';
    const occasion = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
    const phase = phases[id] ?? 'default';

    switch (phase) {
      case 'loading':
        return (
          <TreeLottieCard
            occasion={occasion}
            onComplete={() => setPhase(id, 'done')}
          />
        );
      case 'done':
        return (
          <TreePlantedCard
            data={item.plantation_card}
            isHomePageCard={true}
          />
        );
      default:
        return (
          <CelebrationCard
            occasion={occasion}
            title={item.greeting?.title}
            subtitle={item.greeting?.subtitle}
            onViewGift={() => setPhase(id, 'loading')}
          />
        );
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignSelf: 'flex-start', width: '100%' }}>
      <Entity
        showEntitySelect
        showManufacturerSelect={false}
        gridSizes={{ entity: { xs: 12 } }}
        desktopmb={1}
      />

      {banners.length > 1 ? (
        <Slider {...sliderSettings}>
          {banners.map((item) => (
            <Box key={item.plantation_id} sx={{ px: 0.5 }}>
              {renderBannerItem(item)}
            </Box>
          ))}
        </Slider>
      ) : (
        banners.length === 1 && renderBannerItem(banners[0])
      )}
    </Box>
  );
};

export default TreeBannerCard;
